(function ($) {
  // ─────────────── Variables ───────────────
  let loadedWidget = false;
  let expandOneTime = false;
  const searchIntervalDelay = 100;
  const hardTimeout = 60000;
  const customDiscountSale = 1;

  let hasOpenedOneTime = false;
  let lastOneTimePack = 2;
  let hasOpenedSubsave = false;
  let lastSubsavePack = 1;

  // ─────────────── Helpers ───────────────
  function formatPrice(p) {
    p = Number(String(p).replace('$', ''));
    let price = p.toFixed(2);
    return String(price).replace('.00', '');
  }

  function disableButton() {
    const $form = $('.product-single__form');
    const variantId = $form.find('[name="id"]').val();
    const available = $form.find(`.jc-custom-rc-available[data-variant-id="${variantId}"]`).data('available');
    const $btn = $form.find('.btn--add-to-cart');
    if (available) {
      $btn.prop('disabled', true).find('#subscription-btn').text('SOLD OUT');
    } else {
      $btn.prop('disabled', false);
      const val = $form.find('.jc-custom-rc-radio__input:checked').val();
      $btn.find('#subscription-btn').text(val === 'subsave' ? 'Add Subscription to Cart' : 'Add to Cart');
    }
  }

  function changePack() {
    const pack = $('.jc-custom-rc-radio__input:checked')
      .next()
      .find('.jc-custom-rc-radio__pack-item.active')
      .data('pack');
    console.log(`Selected pack: ${pack}`);
    $('.jc-js-quantity-selector').val(pack);
    disableButton();
  }

  function changePlan() {
    const plan = $('.jc-custom-rc-radio__plan-item.active').data('plan');
    console.log(`Selected plan: ${plan}`);
    $(`.rc_widget__option__plans__dropdown>option:eq(${plan})`).prop('selected', true);
    disableButton();
  }

  function updateSubscriptionPrices() {
    const $active = $('.jc-custom-subsave .jc-custom-rc-radio__pack-item.active');
    if (!$active.length) return;
    const cmp = $active.find('.jc-custom-rc__compare-price').text().trim();
    const sale = $active.find('.jc-custom-rc__sale-price').text().trim();
    $('.jc-custom-subsave .jc-custom-rc__price-box .jc-custom-rc__compare-price').text(`$${formatPrice(cmp)}`);
    $('.jc-custom-subsave .jc-custom-rc__sale-price').first().text(`$${formatPrice(sale)}`);
  }

  function updateOneTimePrices() {
    let $pack = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item.active');
    if (!$pack.length) {
      const $fallback = $('.jc-custom-onetime.widget .jc-custom-rc-radio__pack-item[data-pack="1"]');
      $pack = (!$loadedWidget || !expandOneTime) ? $fallback : $pack;
    }
    if ($pack.length) {
      const cmp = $pack.find('.jc-custom-rc__compare-price').text().trim();
      const sale = $pack.find('.jc-custom-rc__sale-price').text().trim();
      const discountText = $pack.find('.jc-custom-rc__save-price').text().trim() || 'No Discount';
      const $priceBox = $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price');
      if (cmp == 0) {
        $priceBox.html(`<span class="compare-price"></span> <span class="sale-price">$${formatPrice(sale)}</span>`);
      } else {
        $priceBox.html(`<span class="compare-price">$${formatPrice(cmp)}</span> <span class="sale-price">$${formatPrice(sale)}</span>`);
      }
      $('.jc-custom-onetime .jc-custom-rc__save-price.main')
        .text(discountText)
        .toggleClass('no-discount', discountText === 'No Discount');
    } else {
      $('.jc-custom-onetime .jc-custom-rc__price-box .jc-custom-rc__sale-price').empty();
      $('.jc-custom-onetime .jc-custom-rc__save-price.main')
        .text('No Discount')
        .addClass('no-discount');
    }
  }

    function updatePackPrices(activePack) {
        if (!activePack) return;
        // redraw both sides every time
        updateSubscriptionPrices();
        updateOneTimePrices();
     }

  function changeVariant() {
    const price = Number($('[data-price-onetime]').text().trim().replace('$', ''));
    console.log(price);
    const variantId = $('[name="id"]').val();
    document.dispatchEvent(new CustomEvent('variantChanged', {
      detail: { id: String(variantId) }
    }));
    const customDiscount = 1 - Number($(`.jc-custom-rc-discount[data-variant-id="${variantId}"]`).data('discount')) / 100;

    // Update compare prices
    $('.jc-custom-rc__compare-price').text(`$${formatPrice(price)}`);
    [2, 3].forEach(n => {
      $(`[data-pack="${n}"] .jc-custom-rc__compare-price`).text(`$${formatPrice(price * n)}`);
    });

    if (customDiscount) {
      $('.jc-custom-rc-container').removeClass('no-discount-container');
      // One‑time sale price
      if (loadedWidget && expandOneTime) {
        const active = $('.jc-custom-onetime .jc-custom-rc-radio__pack-item.active').data('pack');
        $('.jc-custom-onetime .jc-custom-rc__sale-price').html(
          `<span class="compare-price">$${formatPrice(price * active)}</span> <span class="sale-price">$${formatPrice(price * active * customDiscount)}</span>`
        );
      } else {
        $('.jc-custom-onetime .jc-custom-rc__sale-price').html(
          `<span class="compare-price">$${formatPrice(price)}</span> <span class="sale-price">$${formatPrice(price * customDiscount)}</span>`
        );
      }
      // Pack-specific sale prices
      [1, 2, 3].forEach(n => {
        $('.jc-custom-onetime').find(`[data-pack="${n}"] .jc-custom-rc__sale-price`)
          .text(`$${formatPrice(price * n * customDiscount)}`);
        $('.jc-custom-subsave').find(`[data-pack="${n}"] .jc-custom-rc__sale-price`)
          .text(`$${formatPrice(price * n * 0.8 * customDiscountSale)}`);
      });
    } else {
      $('.jc-custom-rc-container').addClass('no-discount-container');
      $('.jc-custom-onetime .jc-custom-rc__sale-price').text(`$${formatPrice(price)}`);
      [1, 2, 3].forEach((n, i) => {
        const factor = n === 1 ? 1 : (n === 2 ? 0.9 : 0.85);
        $(`.jc-custom-onetime [data-pack="${n}"] .jc-custom-rc__sale-price`)
          .text(`$${formatPrice(price * n * factor)}`);
        $('.jc-custom-subsave').find(`[data-pack="${n}"] .jc-custom-rc__sale-price`)
          .text(`$${formatPrice(price * n * 0.8 * customDiscountSale)}`);
      });
    }

    updatePackPrices($('.jc-custom-rc-radio__pack-item.active').data('pack'));
    updateOneTimePrices();
    disableButton();
  }

  function updatePromoDisclaimer() {
    const val = $('input[name="custom-rc-radio"]:checked').val();

    // existing subscribe‑only disclaimer
    $('.promo-pdp-disclaimer')[val === 'subsave' ? 'show' : 'hide']();

    // hide the "always‑on" promo‐disclaimer when one‑time is selected
    $('.promo-disclaimer.promo-pdp-disclaimer')[val === 'subsave' ? 'show' : 'hide']();

    $('.promo-static')[val === 'subsave' ? 'show' : 'hide']();
  }


  function updatePrices() {
    document.querySelectorAll('.jc-custom-rc__compare-price').forEach(el => {
      el.textContent = `$${formatPrice(el.textContent.trim())}`;
    });
    document.querySelectorAll('.jc-custom-rc__sale-price').forEach(el => {
      const cmp = el.querySelector('.compare-price');
      if (cmp) {
        cmp.textContent = `$${formatPrice(cmp.textContent.trim())}`;
        el.querySelector('.sale-price').textContent = `$${formatPrice(el.querySelector('.sale-price').textContent.trim())}`;
      } else {
        el.textContent = `$${formatPrice(el.textContent.trim())}`;
      }
    });
  }

  let searchInterval;
  function searchElement() {
    if (!$('[data-widget-container-wrapper]').length) return;
    updatePrices();
    setTimeout(() => {
      if (!window.location.search.includes('?variant=')) {
        if ($('.single-option-selector__radio[value="2500mg"]').length) {
          $('.single-option-selector__radio[value="2500mg"]').next().click();
        } else {
          $('.jc-input-index-2[name="potency"]').next().click();
        }
      } else if ($('.jc-product-page-content-wrapper').data('productId') === "8476876275910") {
        const vid = new URLSearchParams(window.location.search).get("variant");
        $('[data-variant-id]').each((i, el) => {
          if (el.dataset.variantId === vid) {
            const wrappers = document.querySelectorAll('fieldset[name="potency"] > .jc-product-page-input-wrapper');
            const variantEl = wrappers[i];
            const nextVariant = getNextElement(variantEl);
            nextVariant.querySelector('input[type="radio"]').click();
            variantEl.querySelector('.jc-product-page-input-label.potency').click();
          }
        });
      }
      $('.jc-custom-rc-loading').hide();
      $('.jc-custom-rc-container').fadeIn(200);
      loadedWidget = true;
      disableButton();
      clearInterval(searchInterval);
    }, searchIntervalDelay);
  }

  function stopSearch() {
    clearInterval(searchInterval);
  }

  function showDiscountBadgeIfAny() {
    document.querySelectorAll('.discount-tab.pdp').forEach(el => el.remove());
    const el = document.getElementById('currentVariantDiscount');
    const val = parseInt(el?.getAttribute('data-variant-discount') || '0', 10);
    if (val > 0) {
      const pane = document.querySelector('.tabs-content-product .w-tab-pane.w--tab-active');
      if (!pane) return;
      const badge = document.createElement('div');
      badge.className = 'discount-tab pdp';
      badge.innerHTML = `<span class="discount-text">save</span><span class="discount-text bigger">${val}%</span>`;
      pane.appendChild(badge);
    }
  }

  function getNextElement(el) {
    const list = Array.from(document.querySelectorAll('fieldset[name="potency"] > .jc-product-page-input-wrapper'));
    const idx = list.indexOf(el);
    return list[(idx + 1) % list.length];
  }

  function getSelectedVariantId() {
    return String(
      ShopifyAnalytics?.meta?.selectedVariantId ||
      document.querySelector('form[action="/cart/add"] input[name="id"]')?.value ||
      new URLSearchParams(window.location.search).get('variant') ||
      document.getElementById('ProductSelect')?.value ||
      document.querySelector('.single-option-selector__radio:checked')?.value ||
      ''
    );
  }

  // ─────────────── Variant Thumbnails ───────────────
  function updateVariantThumbnails() {
    const vid = getSelectedVariantId();
    if (!vid) return console.log('❓ no variant selected');
    const jsonEl = document.getElementById('ProductJson-{{ section.id }}');
    if (!jsonEl) return console.error('Missing ProductJson');
    const pd = JSON.parse(jsonEl.textContent);
    const variant = pd.variants.find(v => String(v.id) === vid);
    const src = variant?.featured_image?.src || pd.featured_image?.src;
    if (!src) return console.warn('No featured image');
    const normalize = u => u.replace(/^https?:/, '');
    const featured = normalize(src);
    const container = document.querySelector('.tabs-wrapper-product .tabs-product');
    if (!container) return console.error('Cannot find .tabs-product');
    const panes = Array.from(container.querySelectorAll('.w-tab-pane')).map(pane => ({
      id: pane.dataset.imageId,
      pane,
      src: normalize(pane.querySelector('img')?.src || '')
    }));
    let start = panes.findIndex(d => d.src === featured);
    if (start < 0) return console.error('Featured not in panes');
    const thumbs = Array.from({ length: 5 }, (_, i) => panes[(start + i) % panes.length]);
    const menu = container.querySelector('.tabs-menu-product');
    menu.innerHTML = thumbs.map((t, i) => `
      <a href="#" data-image-id="${t.id}" class="tab-menu-link-product w-inline-block w-tab-link${i ? '' : ' w--current'}" style="background-image:url(${t.src});"></a>
    `).join('');
    menu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        menu.querySelectorAll('a').forEach(a => a.classList.toggle('w--current', a === link));
        panes.forEach(d => {
          const show = d.id === link.dataset.imageId;
          d.pane.style.display = show ? '' : 'none';
          d.pane.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      });
    });
    menu.querySelector('a')?.click();
  }

  // ─────────────── Hidden Input Mapping ───────────────
  function initVariantMapping() {
    const mapping = {
      "44502852436166": "37546503733446",
      "44502852468934": "42726923010246",
      "44502852501702": "43162448625862"
    };
    const form = document.querySelector('form[action="/cart/add"]');
    const select = document.getElementById('ProductSelect');
    if (!form || !select) return;
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = 'id';
    form.appendChild(hiddenInput);

    function updateHidden() {
      const val = select.value;
      hiddenInput.value = mapping[val] || val;
    }
    select.addEventListener('change', updateHidden);
    let last = select.value;
    setInterval(() => {
      if (select.value !== last) {
        last = select.value;
        updateHidden();
      }
    }, 300);
    document.addEventListener('variant:changed', updateHidden);
    form.addEventListener('submit', () => select.removeAttribute('name'));
    updateHidden();
  }

  // ─────────────── Pack Selection Event ───────────────
  function initPackSelection() {
    const items = document.querySelectorAll('.jc-custom-rc-radio__pack-item');
    if (!items.length) return;
    items.forEach(i => {
      i.addEventListener('click', () => {
        items.forEach(j => j.classList.remove('active'));
        i.classList.add('active');
        const pack = i.dataset.pack;
        window.selectedPack = pack;
        document.dispatchEvent(new CustomEvent('pack:changed', { detail: { pack } }));
      });
    });
    // Initialize
    const active = document.querySelector('.jc-custom-rc-radio__pack-item.active');
    if (active) {
      document.dispatchEvent(new CustomEvent('pack:changed', { detail: { pack: active.dataset.pack } }));
    }
  }

  // ─────────────── Potency Popup ───────────────
  function initPotencyPopup() {
    const buttons = document.querySelectorAll('.potency-btn');
    const popup = document.getElementById('potencyPopup');
    buttons.forEach(btn => btn.addEventListener('click', e => {
      e.preventDefault();
      popup.style.display = 'flex';
    }));
    popup.addEventListener('click', e => {
      if (e.target === popup) popup.style.display = 'none';
    });
    const closeBtn = document.querySelector('.close-btn');
    if (closeBtn) closeBtn.addEventListener('click', () => popup.style.display = 'none');
  }

  // ─────────────── Variant Label Update ───────────────
  function initVariantLabel() {
    function updateLabel() {
      const id = ShopifyAnalytics.meta.selectedVariantId;
      let note = window.variantPriceNotes[id];
      if (note) note = $('<textarea/>').html(note).text();
      if (note) {
        $('.jc-custom-subsave .jc-custom-rc__label-heading').text("Subscribe & Save ~35%");
      }
    }
    $(document).on('change', '.single-option-selector__radio', updateLabel);
  }

  // ─────────────── Initialization ───────────────
  $(document).ready(function() {
    // ───────── Always-bound initializers ─────────
    updatePromoDisclaimer();
    searchInterval = setInterval(searchElement, searchIntervalDelay);
    setTimeout(stopSearch, hardTimeout);
    showDiscountBadgeIfAny();
    initVariantMapping();
    initPackSelection();
    initPotencyPopup();
    initVariantLabel();
  
    // ───────── Variant change: reset packs → default to 1-Pack ─────────
    $(document).on('change', '.jc-product-page-form-wrapper .single-option-selector__radio', function() {
      console.log('[DEBUG] variant changed, resetting packs to 1');
      // 1) put both One-Time & Subscribe back to 1-Pack
      $('.jc-custom-onetime .jc-custom-rc-radio__pack-item, .jc-custom-subsave .jc-custom-rc-radio__pack-item')
        .removeClass('active')
        .filter('[data-pack="1"]').addClass('active');
  
      // 2) reset our memory of “last pack opened”
      lastOneTimePack  = 1;
      lastSubsavePack  = 1;
      hasOpenedOneTime = false;
      hasOpenedSubsave= false;
  
      // 3) redraw both sides
      updateOneTimePrices();
      updateSubscriptionPrices();
  
      // 4) finally re-run your normal variant logic
      setTimeout(changeVariant, 100);
      updatePromoDisclaimer();
    });
  
    // ───────── Pack clicks ─────────
    $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-rc-radio__pack-item', function(e) {
      e.preventDefault(); e.stopPropagation();
      const $w   = $(this).closest('.jc-custom-rc-radio');
      const pack = $(this).data('pack');
      $w.find('.jc-custom-rc-radio__pack-item').removeClass('active');
      $(this).addClass('active');
      if ($w.hasClass('jc-custom-onetime')) {
        lastOneTimePack = pack;
        updateOneTimePrices();
      } else {
        lastSubsavePack = pack;
        updateSubscriptionPrices();
      }
      changePack();
      disableButton();
    });
  
// ───────── Subscribe vs One-Time toggle ─────────
$(document).on('change', '.jc-product-page-form-wrapper .jc-custom-rc-radio__input', function() {
  const val = $(this).val();
  expandOneTime = (val === 'onetime');
  console.log('[DEBUG] purchase type:', val);

  // grab the Recharge “plans” dropdown
  const $planSelect = $('.rc_widget__option__plans__dropdown');

  if (val === 'subsave') {
    // enable it so Shopify/ReCharge will include it
    $planSelect
      .prop('disabled', false)
      .attr('name', 'selling_plan');

    // restore last subscribe-pack
    const $subs = $('.jc-custom-subsave .jc-custom-rc-radio__pack-item')
      .removeClass('active')
      .filter(`[data-pack="${lastSubsavePack}"]`).addClass('active');

    updateSubscriptionPrices();
    $('#subscription-btn').text('Add Subscription to Cart');
  } else {
    // disable + remove name so it's treated as one-time
    $planSelect
      .prop('disabled', true)
      .removeAttr('name');

    // restore last one-time pack
    const $ones = $('.jc-custom-onetime .jc-custom-rc-radio__pack-item')
      .removeClass('active')
      .filter(`[data-pack="${lastOneTimePack}"]`).addClass('active');

    updateOneTimePrices();
    $('#subscription-btn').text('Add to Cart');
  }

  // re-sync pack qty, sold-out guard, disclaimers
  changePack();
  disableButton();
  updatePromoDisclaimer();
});

  
    // ───────── Plan clicks ─────────
    $(document).on('click', '.jc-product-page-form-wrapper .jc-custom-rc-radio__plan-item', function() {
      $('.jc-custom-rc-radio__plan-item').removeClass('active');
      $(this).addClass('active');
      changePlan();
    });
  
    // ───────── Thumbnail updater ─────────
    setTimeout(updateVariantThumbnails, 100);
    function onVariantChangeThumbs() { setTimeout(updateVariantThumbnails, 50); }
    $(document).on('change', '[name="id"], .single-option-selector__radio', onVariantChangeThumbs);
    $(document).on('variantChanged variant:changed', onVariantChangeThumbs);
  });
  
})(jQuery);


